export const STAGES = [
  { key: "draft", label: "Draft", short: "Draft" },
  { key: "offer_sent", label: "Offer Sent", short: "Sent" },
  { key: "offer_accepted", label: "Offer Accepted", short: "Accepted" },
  { key: "docs_pending", label: "Docs Pending", short: "Docs" },
  { key: "in_review", label: "In Review", short: "Review" },
  { key: "final_approval", label: "Final Approval", short: "Final" },
  { key: "funded", label: "Funded", short: "Funded" },
];

export const TERMINAL = [
  { key: "declined", label: "Declined" },
  { key: "expired", label: "Expired" },
];

export const ALL_STAGES = [...STAGES, ...TERMINAL];

export const PIPELINE_ORDER = [
  "draft", "offer_sent", "offer_accepted", "docs_pending",
  "in_review", "final_approval", "funded", "declined", "expired",
];

export const stageMeta = (key) => {
  const map = {
    draft: { label: "Draft", color: "#94A3B8", bg: "rgba(148,163,184,0.14)" },
    offer_sent: { label: "Offer Sent", color: "#38BDF8", bg: "rgba(56,189,248,0.14)" },
    offer_accepted: { label: "Offer Accepted", color: "#818CF8", bg: "rgba(129,140,248,0.14)" },
    docs_pending: { label: "Docs Pending", color: "#FBBF24", bg: "rgba(251,191,36,0.14)" },
    in_review: { label: "In Review", color: "#F59E0B", bg: "rgba(245,158,11,0.14)" },
    final_approval: { label: "Final Approval", color: "#A78BFA", bg: "rgba(167,139,250,0.14)" },
    funded: { label: "Funded", color: "#10B981", bg: "rgba(16,185,129,0.16)" },
    declined: { label: "Declined", color: "#F87171", bg: "rgba(248,113,113,0.14)" },
    expired: { label: "Expired", color: "#9CA3AF", bg: "rgba(156,163,175,0.14)" },
  };
  return map[key] || map.draft;
};

// merchant-facing stepper
export const MERCHANT_STEPS = [
  { key: "offer_sent", label: "Offer Sent" },
  { key: "offer_accepted", label: "Offer Accepted" },
  { key: "docs_review", label: "Documents Under Review" },
  { key: "final_approval", label: "Final Approval" },
  { key: "funded", label: "Funded" },
];

export const docStatusMeta = (status) => {
  const map = {
    missing: { label: "Required", color: "#94A3B8", bg: "rgba(148,163,184,0.14)" },
    pending: { label: "Pending Review", color: "#FBBF24", bg: "rgba(251,191,36,0.16)" },
    approved: { label: "Approved", color: "#10B981", bg: "rgba(16,185,129,0.16)" },
    rejected: { label: "Action Needed", color: "#F87171", bg: "rgba(248,113,113,0.16)" },
  };
  return map[status] || map.missing;
};
